module.exports = __webpack_public_path__ + "img/pen.30a1d68.svg";